module.exports = __webpack_public_path__ + "static/footer-boat-9faf5b018334b2bb751981c51145f87a.png";